import { Module } from "vuex";
import { CompanyState } from "./types";
import { RootState } from "../../types";
import { getters } from "./getters";
import { actions } from "./actions";
import { mutations } from "./mutations";

const state: CompanyState = {
  company: "",
  creditCode: "",
};
const namespaced = true;
export const company: Module<CompanyState, RootState> = {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
export default state;
